module.exports = "/build/web/images/team/default-stadion.480f0a1b4e6b0016c04ee03738318d2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/team/default-stadion.jpg
// module id = 139
// module chunks = 24